// AboutCommunity.jsx
import React from 'react';
import './AboutCommunity.css';
import aboutCommunity from '../../assets/AboutCommunity.jpg';

const AboutCommunity = () => {
  return (
    <section className="about-section">
      <div className="about-container">
        <h1 className="about-title">
          About Our Community
        </h1>
        
        <p className="about-page-subtitle">
          Exploring the frontiers of quantum technology, fostering innovation, and
          building a collaborative future.
        </p>

        <div className="about-image-placeholder">
          <img 
            src={aboutCommunity}
            alt="Community Icon"
            className="about-image"
          />
        </div>

        <p className="about-description">
          Our community brings together researchers, industry experts, academics, and enthusiasts
          passionate about advancing quantum technology and its applications across various fields.
        </p>
      </div>
    </section>
  );
};

export default AboutCommunity;